import React from "react";
import { Typography, useTheme } from "@mui/material";
import styled from "@emotion/styled";
import ErrorIcon from "@icons/myicons/warning-circle-filled.svg?react";
import { Tooltip } from "@components";

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing(1)};
`;

export interface Props {
  message: string;
  testId?: string;
}

export const ParsingResultActivitiesError = ({ message, testId }: Props) => {
  const theme = useTheme();

  return (
    <Container data-testid={testId || "activity-with-booking-error"}>
      <Tooltip
        text={<Typography variant="body3">{message}</Typography>}
        placement="top"
      >
        <ErrorIcon color={theme.palette.error.main} />
      </Tooltip>
    </Container>
  );
};
